export default {
  'Bonus_Tasks': 'Bonus Tasks',
  'Coupons': 'Coupons',
  'Process': 'Process',
  'Expiry_date': 'Expiry date',
  'coupons_available': 'Available',
  'coupons_unavailable': 'Unavailable',
  'to_trade': 'To Trade',
  'Distributed': 'Distributed',
  'Receive': 'Receive',
  'term_of_use': 'Term of Use',
  'claim_successfully': 'Claim Successfully'
}